import { Button, ButtonProps } from '@chakra-ui/react'

export const ReloadButton = (props: ButtonProps) => (
  <Button
    variant="tertiary"
    size="md"
    fontSize="12px"
    fontWeight="700"
    {...props}
  >
    Reload
  </Button>
)
